import * as Raven from 'raven-js';
import * as $ from 'jquery';
import * as ko from 'knockout';
import {CurrencyRatesComponent} from './currency/currency-rates';
import {CurrencyCalculatorComponent} from './currency/currency-calculator';
import {OpinionsComponent} from './home/opinions';
import {BanksComponent} from './home/banks';
import {WhoTrustedComponent} from './home/who-trusted';
import {WhoTrustedDoradcyFirmyComponent} from "./home/who-trusted-doradcyfirmy";
import {LoginStatusComponent} from './home/login-status';
import {BannersComponent} from './home/banners';
import {TranslateComponent} from './common/translate';
import {InfoPage} from './info-page';
declare var DKPROD: boolean;
declare var DobryKantor;
import {init} from './knockout-extensions';
import {NbpCurrencyRateComponent} from "./currency/nbp-currency-rate";
import {OpinionsNordiqaComponent} from "./home/opinions-nordiqa";
import {CurrencyChartComponent} from "./currency/currency-chart";
import {OpinionsDoradcyFirmyComponent} from "./home/opinions-doradcyfirmy";
import {BanksDoradcyFirmyComponent} from "./home/banks-doradcyfirmy";
import {PartnerDiamentComponent} from "./home/partner-diament";
import {KontaktDiamentComponent} from "./home/kontakt-diament";
import "jquery-validation";
import "jquery-form";
import "hammerjs"
import "knockout-mapping";
import "chart.js";

if (DKPROD) {
    Raven.config('https://b95425c8c70549feaf9072e315f2357d@sentry.io/127528').install();
}

(function($: any) {
    var previousScroll = 0;

    $.ajaxSetup({
        xhrFields: {
            withCredentials: true
        }
    });

    $.validator.setDefaults({
        errorClass: 'validation-error',
        validClass: 'validation-success',
        errorPlacement: function(error, element) {
            error.appendTo(element.parent()).hide().slideDown('normal');
        }
    });

    function setHeaderClass() {
        var scroll = $(window).scrollTop();

        if (!$("#header-menu").hasClass('small-force')) {
            if (scroll >= 100 && previousScroll < 100) {
                $('#main').addClass("small");
                $("#header-top").addClass("small");
                $("header").addClass("small");
                $("#header-menu").addClass("small");

                $("#header-menu-logo").removeClass("logo-back-animation");
                $("#header-menu-logo").addClass("logo-animation");
            } else if (scroll < 100 && previousScroll >= 100) {
                $('#main').removeClass("small");
                $("#header-top:not(.small-force)").removeClass("small");
                $("header").removeClass("small");
                $("#header-menu").removeClass("small");

                $("#header-menu-logo").addClass("logo-back-animation");
                $("#header-menu-logo").removeClass("logo-animation");
            }
        }

        previousScroll = $(window).scrollTop();
    }

    $(window).scroll(setHeaderClass);

    $('.menu-toggle').click(function() {
        $('dk-currency-rates-column').hide();
        $('#main-nav-container').toggle();
        $('.mobile-menu').toggle();
        window.scrollTo(0,0);

        if ($('#main-nav-container').is(':visible')) {
            $('html').addClass('main-nav-container-visible');
        } else {
            $('html').removeClass('main-nav-container-visible');
        }

        return false;
    });

    $('#menu-close').click(function() {
        $('#main-nav-container').hide();
        $('html').removeClass('main-nav-container-visible');
        return false;
    });

    $('.menu-close').click(function(event) {
        event.stopPropagation();
        $('#main-nav-container').hide();
        $('html').removeClass('main-nav-container-visible');
        return false;
    });

    $('#cookies .button').click(function() {
        $('#cookies').remove();
        return false;
    });

    $('#header-nav-toggle').click(function() {
        $('#header-nav').toggle();
    });

    $('#header-nav').find('a').click(function() {
        $('#header-nav').toggle();
    });

    //Chowanie tabeli walut
    $('body').on('click', '#currency-rates-column-overlay', function() {
        $('dk-currency-rates-column').hide();
        $('html').removeClass('main-nav-container-visible');
    });

    $('body').on('click', '#currency-rates-column', function(event) {
        event.stopPropagation();
    });

    $('body').on('touchend', '#currency-rates-column-overlay', function() {
        $('dk-currency-rates-column').hide();
        $('html').removeClass('main-nav-container-visible');
    });

    $('body').on('touchend', '#currency-rates-column', function(event) {
        event.stopPropagation();
    });

    //Chowanie menu
    $('body').on('click', '#main-nav-container', function() {
        $('#main-nav-container').hide();
        $('html').removeClass('main-nav-container-visible');
    });

    $('body').on('click', 'nav', function(event) {
        event.stopPropagation();
    });

    $('body').on('touchend', '#main-nav-container', function() {
        $('#main-nav-container').hide();
        $('html').removeClass('main-nav-container-visible');
    });

    $('body').on('touchend', 'nav', function(event) {
        event.stopPropagation();
    });

    $('.main-nav-logout').click(() => {
        $('#header-logout-button').click();
    });

    $('#header-menu-mobile-show-currency-rates').click(() => {
        $('html').scrollTop();
        $('html').toggleClass('main-nav-container-visible');
        $('dk-currency-rates-column').toggle();
    });

    $('#walutowe-love form').validate({
        rules: {
            freshmail_email: {
                required: true,
                email: true
            }
        },
        messages: {
            freshmail_email: {
                required: 'Proszę wpisać adres e-mail.',
                email: 'Proszę wpisać adres e-mail.'
            }
        }
    });

    setTimeout(function() {
        $('#welcome-popup').remove();
    }, 12000);

    let infoPage = new InfoPage();
    infoPage.init();
    setHeaderClass();

    if (DobryKantor.params.inProduction) {
        (function (d, s, id) {
            var js, fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) return;
            js = d.createElement(s);
            js.id = id;
            js.src = "//connect.facebook.net/pl_PL/sdk.js#xfbml=1&version=v2.9&appId=168757696501402";
            fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'));
    }
})($);

(() => {
    init();

    ko.components.register('dk-t', {
        viewModel: TranslateComponent,
        template: require('./common/translate.html')
    });

    ko.components.register('dk-currency-rates', {
        viewModel: CurrencyRatesComponent,
        template: require('./currency/currency-rates.html')
    });

    ko.components.register('dk-currency-rates-tablet-mobile', {
        viewModel: CurrencyRatesComponent,
        template: require('./currency/currency-rates-tablet-mobile.html')
    });

    ko.components.register('dk-currency-rates-table', {
        viewModel: function() { return this; },
        template: require('./currency/currency-rates-table.html')
    });

    ko.components.register('dk-currency-rates-table-diament', {
        viewModel: CurrencyRatesComponent,
        template: require('./currency/currency-rates-table-diament.html')
    });

    ko.components.register('dk-currency-rates-table-only', {
        viewModel: CurrencyRatesComponent,
        template: require('./currency/currency-rates-table-only.html')
    });

    ko.components.register('dk-currency-rates-column', {
        viewModel: CurrencyRatesComponent,
        template: require('./currency/currency-rates-column.html')
    });

    ko.components.register('dk-currency-calculator', {
        viewModel: CurrencyCalculatorComponent,
        template: require('./currency/currency-calculator.html')
    });

    ko.components.register('dk-opinions', {
        viewModel: OpinionsComponent,
        template: require('./home/opinions.html')
    });

    ko.components.register('dk-opinions-nordiqa', {
        viewModel: OpinionsNordiqaComponent,
        template: require('./home/opinions-nordiqa.html')
    });

    ko.components.register('dk-banks', {
        viewModel: BanksComponent,
        template: require('./home/banks.html')
    });

    ko.components.register('dk-login-status', {
        viewModel: LoginStatusComponent,
        template: require('./home/login-status.html')
    });

    ko.components.register('dk-login-status-konik', {
        viewModel: LoginStatusComponent,
        template: require('./home/login-status-konik.html')
    });

    ko.components.register('dk-login-status-diament', {
        viewModel: LoginStatusComponent,
        template: require('./home/login-status-diament.html')
    });

    ko.components.register('dk-login-status-doradcyfirmy', {
        viewModel: LoginStatusComponent,
        template: require('./home/login-status-doradcyfirmy.html')
    });

    ko.components.register('dk-who-trusted', {
        viewModel: WhoTrustedComponent,
        template: require('./home/who-trusted.html')
    });

    ko.components.register('dk-who-trusted-doradcyfirmy', {
        viewModel: WhoTrustedDoradcyFirmyComponent,
        template: require('./home/who-trusted-doradcyfirmy.html')
    });

    ko.components.register('dk-banks-doradcyfirmy', {
        viewModel: BanksDoradcyFirmyComponent,
        template: require('./home/banks-doradcyfirmy.html')
    });

    ko.components.register('dk-opinions-doradcyfirmy', {
        viewModel: OpinionsDoradcyFirmyComponent,
        template: require('./home/opinions-doradcyfirmy.html')
    });

    ko.components.register('dk-banners', {
        viewModel: BannersComponent,
        template: require('./home/banners.html')
    });

    ko.components.register('dk-nbp-currency-rate', {
       viewModel: NbpCurrencyRateComponent,
       template: require('./currency/nbp-currency-rate.html')
    });

    ko.components.register('dk-currency-chart', {
        viewModel: CurrencyChartComponent,
        template: require('./currency/currency-chart.html')
    });

    ko.components.register('dk-partner-diament', {
        viewModel: PartnerDiamentComponent,
        template: require('./home/partner-diament.html')
    });

    ko.components.register('dk-kontakt-diament', {
        viewModel: KontaktDiamentComponent,
        template: require('./home/kontakt-diament.html')
    });

    ko.applyBindings({}, document.getElementsByTagName('body').item(0));
})();